import { useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useQuery } from "@tanstack/react-query";
import { getCountryList } from "services/data.internal.service";

import { FormTitle, Text, SelectField } from "ui-components/Form";

const option = {
  shipZoneGroup1: [
    "Northern Region",
    " Central Region",
    "Southern Region",
    "East Coast",
    "East Msia",
    "Oversea",
  ],
  countryCode: ["MY", "SG"],
};

function ShippingZoneInfo({ formRender, control, errors, mode = "ADD" }) {
  const [countries, setCountries] = useState([]);
  useQuery({
    queryKey: ["country-options"],
    queryFn: () => getCountryList({ active: true }),
    onSuccess: (data) => setCountries(data.data.data.map((x) => x.countryCode)),
  });
  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit Shipping Zone Information" : "Shipping Zone Information"}
      />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, size, ...data } = property;
              const xs = size ? size : 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "shipZoneGroup1":
                      options = option.shipZoneGroup1;
                      break;
                    case "countryCode":
                      options = countries;
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ShippingZoneInfo;
